import * as Sentry from "@sentry/react";
import { Suspense } from "react";
import { ErrorScreen } from "./components/ErrorScreen";
import { FullPageLoader } from "./components/FullPageLoader";
import { ScreenWrapper } from "./components/ScreenWrapper";
import { lazyWithRetry } from "./lib/importWithRetry";
import { EventStoreProvider } from "./providers/eventStore/EventStoreProvider";
import { ScriptProvider } from "./providers/script/ScriptProvider";
import { UserProvider } from "./providers/user/UserProvider";
import { Router, Screen } from "./router";
import { WelcomeScreen } from "./screens/WelcomeScreen";

import "@ancestors/components/global.css";

const Slides = lazyWithRetry(() => import("./Slides"));
const RegistrationScreen = lazyWithRetry(() => import("./screens/RegistrationScreen"));
const SelfieScreen = lazyWithRetry(() => import("./screens/selfie/SelfieScreen"));
const OnboardingScreen = lazyWithRetry(() => import("./screens/onboarding/OnboardingScreen"));
const InterfaceScreen = lazyWithRetry(() => import("./screens/interface/InterfaceScreen"));

export default function App() {
  const isSlide = window.location.pathname.startsWith("/slides");

  if (isSlide) {
    return (
      <EventStoreProvider>
        <Slides />
      </EventStoreProvider>
    );
  }

  return (
    <AppWrapper>
      <Router>
        <Screen name="Welcome" component={WelcomeScreen} />
        <Screen name="Registration" component={RegistrationScreen} />
        <Screen name="Selfie" component={SelfieScreen} />
        <Screen name="Onboarding" component={OnboardingScreen} />
        <Screen name="Interface" component={InterfaceScreen} />
      </Router>
    </AppWrapper>
  );
}

function AppWrapper({ children }: { children: React.ReactNode }) {
  return (
    <EventStoreProvider>
      <UserProvider>
        <ScreenWrapper>
          {/* Error boundary without script provider */}
          <Sentry.ErrorBoundary fallback={ErrorScreen}>
            <Suspense fallback={<FullPageLoader />}>
              <ScriptProvider>
                {/* Error boundary with script provider */}
                <Sentry.ErrorBoundary fallback={ErrorScreen}>{children}</Sentry.ErrorBoundary>
              </ScriptProvider>
            </Suspense>
          </Sentry.ErrorBoundary>
        </ScreenWrapper>
      </UserProvider>
    </EventStoreProvider>
  );
}
